import { render, staticRenderFns } from "./expenseList.vue?vue&type=template&id=244bd9a2&scoped=true"
import script from "./expenseList.vue?vue&type=script&lang=js"
export * from "./expenseList.vue?vue&type=script&lang=js"
import style0 from "./expenseList.vue?vue&type=style&index=0&id=244bd9a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244bd9a2",
  null
  
)

export default component.exports